import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Button,
    Divider,
    Typography,
    ToggleButtonGroup,
    ToggleButton
} from '@mui/material';

import NotificationListItem from '../../menuitem/NotificationListItem';

export default function NotificationContent(props) {

    const { allNotifications, setAllNotifications, updateNotification } = props;
    const { user } = useAuth0()

    const [readButtonHover, setReadButtonHover] = useState(false)

    const [notificationViewType, setNotificationViewType] = useState('unread')
    const [filteredNotifications, setFilteredNotifications] = useState(allNotifications.filter(item => item.status?.[user?.sub] === 1 || item.status === undefined))



    useEffect(()=>{
        // If in unread mode, only show notifs with status.{this user} === 1 (unread)
        //    or no status set (also means unread)
        if (notificationViewType == 'unread'){
            setFilteredNotifications(allNotifications.filter(item => item.status?.[user?.sub] === 1 || item.status?.[user?.sub] === undefined));
        } else if (notificationViewType == 'all'){
            setFilteredNotifications(allNotifications)
        }
    },[allNotifications, notificationViewType])

    
    const markNotificationRead = (index) => {
        let updatedNotification = filteredNotifications[index];
        updatedNotification = {
            ...updatedNotification,
            status: {
                ...updatedNotification.status,
                [user?.sub]: 0
            }
        };
        
        setAllNotifications(prev => 
            prev.map((notification) => 
                notification.id === updatedNotification.id ? updatedNotification : notification
            )    
        );
        setFilteredNotifications(prev => 
            prev.map((notification) => 
                notification.id === updatedNotification.id ? updatedNotification : notification
            )    
        );
        updateNotification("mark_read", updatedNotification);
    };

    const markAllRead = () => {
        let updatedNotifications = allNotifications.map(notification => ({
            ...notification,
            status: {
                ...notification.status,
                [user?.sub] : 0
            }
        }))
        setAllNotifications(updatedNotifications)
        updateNotification("mark_read", updatedNotifications)
    }

    const handleNotifViewChange = (
        event, newViewType
      ) => {
        // For styling purposes
        setNotificationViewType(newViewType);
      };




    return (
        <React.Fragment>
            <Box
                minWidth='350px'
                maxWidth='350px'
                maxHeight='450px'
                display='flex'
                flexDirection='column'
            >

                <Box
                    width='100%'
                    display='flex'
                    flexDirection='row'
                    justifyContent='space-between'
                >
                    <Typography variant="subtitle2" paddingBottom='10px'>
                        Notifications
                    </Typography>
                    <ToggleButtonGroup
                        color="success"
                        value={notificationViewType}
                        exclusive
                        onChange={handleNotifViewChange}
                        aria-label="Notification-Viewset"
                    >
                        <ToggleButton 
                            value="all"
                            sx={{height:'30px'}}
                        >
                            All
                        </ToggleButton>
                        <ToggleButton 
                            value="unread"
                            sx={{height:'30px'}}
                        >
                            Unread
                        </ToggleButton>
                    </ToggleButtonGroup>
                    
                </Box>
                <Divider style={{ backgroundColor: '#575757' }}/>
                <Box
                    display='flex'
                    flexDirection='column-reverse'
                    height='100%'
                    sx={{
                        overflowY: 'auto'
                    }}
                >
                    {filteredNotifications.map((notification, index) => (
                        <NotificationListItem
                            key={index}
                            index={index}
                            notification={notification}
                            handleClick={markNotificationRead}
                            user={user}
                        />
                    ))}
                </Box>
                <Box
                    display='flex'
                    justifyContent='flex-end'
                >
                    {filteredNotifications.some(notification => 
                    notification?.status?.[user?.sub] > 0 ||
                    notification?.status?.[user?.sub] === undefined
                ) &&
                        <Button
                            onMouseEnter={() => setReadButtonHover(true)}
                            onMouseLeave={() => setReadButtonHover(false)}
                            onClick={markAllRead}
                            sx={{
                                fontSize: '10px',
                                color: readButtonHover ? 'rgb(255, 255, 255)' : 'rgb(150, 150, 150)',
                                px: '10px'
                            }}
                        >
                            MARK ALL AS READ
                        </Button>
                    }
                </Box>
            </Box>
        </React.Fragment>
    );
}